module.exports = __webpack_public_path__ + "static/media/icon-calendar.8cc0e725.svg";